import React, { useContext, useRef, useState, useEffect } from 'react';
import { SunIcon, MoonIcon, BellIcon } from '@heroicons/react/24/outline';
import { ThemeContext } from '../context/ThemeContext';
import { useUser } from '../context/AuthContext';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import profile_icon from '../assets/profile-user.webp';

const Navbar = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { isLoggedIn, logout, user } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const profileRef = useRef(null);

  // Close profile menu on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setIsProfileMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/admin/auth');
    setIsProfileMenuOpen(false);
  };

  return (
    <header className="flex items-center justify-between px-6 py-4 bg-bg border-b border-border">
      <h1 className="text-xl font-semibold text-txt">Admin Panel</h1>
      <div className="flex items-center space-x-4">
        <button onClick={toggleTheme} className="p-2 rounded-full hover:bg-border">
          {theme === 'light' ? <MoonIcon className="h-6 w-6 text-txt" /> : <SunIcon className="h-6 w-6 text-txt" />}
        </button>
        <BellIcon className="h-6 w-6 text-txt" />

        {isLoggedIn ? (
          <div ref={profileRef} className="relative">
            <button
              onClick={() => setIsProfileMenuOpen(open => !open)}
              className="flex items-center p-1 rounded-full hover:bg-border"
            >
              <img src={profile_icon} alt="Profile" className="h-8 w-8 rounded-full" />
            </button>
            {isProfileMenuOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-bg border border-border rounded shadow-lg">
                <div className="px-4 py-2 text-sm text-txt">
                  <div className="font-semibold">{user?.name}</div>
                  <div className="truncate">{user?.email}</div>
                </div>
                <ul className="py-1">
                  <li>
                    <Link
                      to="/admin/profile"
                      className="block px-4 py-2 text-sm text-txt hover:bg-border"
                      onClick={() => setIsProfileMenuOpen(false)}
                    >
                      Profile
                    </Link>
                  </li>
                  <li>
                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2 text-sm text-txt hover:bg-border"
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        ) : (
          <Link
            to="/admin/auth"
            className="flex items-center space-x-1 p-2 rounded hover:bg-border text-txt"
          >
            <span>Login</span>
          </Link>
        )}
      </div>
    </header>
  );
};

export default Navbar;
